<template>

	<div id="companyRegister">
		<div class="wrap container-fluid">
			<div class="row">
				<div class="menu_left">
					<div class="menu_top menu_top_img">
						<!--<img src="" alt="" />-->
						<p class="text-center">
							<img src="../assets/images/logo-register-info.png" alt="" />
						</p>
						<p class="text-center">开发者管理中心</p>
					</div>
				</div>
				<div class="container_right p_background">
					<div class="container_right_info">
						<section class="container_btm">
							<div class="clearfix tb_padding">
								<p class="text-center h3">
									<img src="../assets/images/icon-enterprise-developers-t.png" class="margin_r_7"/>
									注册企业开发者
								</p>
								<div class="container_box">
									<h4 class="message_title">
							    		<span>基本信息</span>
							    		<span class="endnote">
							    			账号名称:
							    			<i>{{mob}}</i>
							    		</span>
							    	</h4>
									<section class="partition_message developer_box publick_form_box developer_basic_box">

										<!--手机号码-->
										<section class="form_box">
											<label class="form_label" for="">手机号码：</label>
											<input type="hidden" v-model="tCloudUserCompany.mobile" />
											<span>{{mob}}</span>
										</section>

										<!--企业名称-->
										<section class="form_box">
											<label class="form_label" for="">企业名称：</label>
											<input type="text" class="form-control form_control" id="company_name" placeholder="请输入企业名称" v-model.trim="tCloudUserCompany.companyName" />
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请与企业营业执照保持一致）
						        				</small>
											</p>
										</section>

										<!--营业执照注册号-->
										<section class="form_box">
											<label class="form_label" for="">营业执照注册号：</label>
											<input type="text" class="form-control form_control" id="register_companyNo" placeholder="请输入营业执照注册号" v-model.trim="tCloudUserCompany.companyNo" maxlength="25" />
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请与企业营业执照保持一致）
						        				</small>
											</p>
										</section>

										<!--上传营业执照-->
										<section class="form_box">
											<label class="form_label" for="">上传营业执照：</label>
											<small class="tip_sub_text">
					        					（jpg、png格式的图片，且不超过1M）
					        				</small>
										</section>
										<section class="id_card_box line_block" id="company_no">
											<form id="subform" class="inline-block" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
												<input type="hidden" name="type" value="0" />
												<input type="hidden" id="cardPhoto" readonly="readonly" />
												<div class="left pos-relative file_box_btn text-center" id="echoImgz">
													<input type="file" name="file" @change="uploadPhotoz()" id="register_imgFilez" class="cursor" />
													<img :src="echoImg" class="img_font" alt="" title="" />
													<span class="id_card_text id_card_text_hidd">点击上传营业执照</span>
												</div>
											</form>
										</section>

										<!--联系地址-->
										<section class="form_box">
											<label class="form_label" for="">联系地址：</label>
											<select class="form-control form_control form_select" name="" id="register_addressprovince" v-model="tCloudUserCompany.addressProvince" @change="queryProvinceCity('0','0',$event)">
												<option value="">请选择</option>
												<option v-for="option in provinceOptions" v-bind:value="option.id">
													{{ option.dictionaryname }}
												</option>
											</select>
											<select class="form-control form_control form_select" name="" id="register_addresscity" v-model="tCloudUserCompany.addressCity" @change="queryProvinceCity('0','1',$event)">
												<option value="">请选择</option>
												<option v-for="cityoption in cityOptions" v-bind:value="cityoption.id">
													{{ cityoption.dictionaryname }}
												</option>
											</select>
											<select class="form-control form_control form_select" name="" id="register_addressstreet" v-model="tCloudUserCompany.addressStreet" @change="queryProvinceCity('0','2',$event)">
												<option value="">请选择</option>
												<option v-for="streetoption in streetOptions" v-bind:value="streetoption.id">
													{{ streetoption.dictionaryname }}
												</option>
											</select>
											<input type="text" class="form-control form_control" id="register_addressdetail" placeholder="请输入详细地址" v-model.trim="tCloudUserCompany.addressDetails" />
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请与企业营业执照保持一致）
						        				</small>
											</p>
										</section>

									</section>
								</div>
								
								<!--结算方式-->
								<div class="container_box">
									<h4 class="message_title">
							    		<span>结算方式</span>
							    		<span class="endnote"><i class="must_color">*</i>为必填项</span>
							    	</h4>
									<section class="partition_message developer_box publick_form_box developer_basic_box">

										<!--开户行-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>开户行：</label>
											<select class="form-control form_control form_select" name="" id="bankNum" style="width: 260px;" v-model.trim="tCloudUserBankcard.bankNum">
												<option disabled="disabled" value="">请选择开户行</option>
												<option v-for="bankoption in bankOptions" v-bind:value="bankoption.id">
													{{ bankoption.dictionaryname }}
												</option>
											</select>
										</section>
										
										<!--开户支行-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>开户支行：</label>
											<input type="text" class="form-control form_control" placeholder="请输入开户支行" id="bankBranch" maxlength="40"  v-model.trim="tCloudUserBankcard.bankBranch"/>
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请务必正确填写开户支行）
						        				</small>
											</p>
										</section>

										<!--卡号-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>卡号：</label>
											<input type="text" class="form-control form_control" placeholder="请输入银行卡号" id="bankCardNo" v-model.trim="tCloudUserBankcard.cardNo"/>
										</section>

										<!--姓名-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>姓名：</label>
											<input type="text" class="form-control form_control" placeholder="请输入开户人姓名" id="cardUsername" maxlength="20" v-model.trim="tCloudUserBankcard.cardUsername"/>
										</section>
									</section>
								</div>

								<div class="container_box">
									<h4 class="message_title">
							    		<span>联系方式</span>
							    		<span class="endnote"><i class="must_color">*</i>为必填项</span>
							    	</h4>
									<section class="partition_message developer_box publick_form_box developer_basic_box">

										<!--联系人姓名-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>联系人姓名：</label>
											<input type="text" class="form-control form_control" id="company_contacts" placeholder="请输入联系人姓名" v-model.trim="tCloudUserCompany.companyContacts" />
										</section>

										<!--电子邮箱-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>电子邮箱：</label>
											<input type="text" class="form-control form_control" id="register_email" placeholder="请输入电子邮箱" v-model.trim="tCloudUserCompany.email" />
											<p class="prompt_msg">
												<small class="tip_sub_text">（用于接收合作邮件及审核通知等重要信息）</small>
											</p>
										</section>

										<!--手机号码-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>手机号码：</label>
											<span>{{mob}}</span>
										</section>

										<!--座机号码-->
										<section class="form_box">
											<label class="form_label" for="">座机号码：</label>
											<input type="text" class="form-control form_control" id="register_spare" placeholder="请输入号码" v-model.trim="tCloudUserCompany.companyPhone" />
											<p class="prompt_msg">
												<small class="tip_sub_text">（座机格式000-00000000）</small>
											</p>
										</section>

										<!--QQ-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>QQ：</label>
											<input type="text" class="form-control form_control" id="register_qq" placeholder="请输入QQ号码" v-model.trim="tCloudUserCompany.qq" />
											<p class="prompt_msg">
												<small class="tip_sub_text">（方便在线实时沟通）</small>
											</p>
										</section>

										<!--官网地址-->
										<section class="form_box">
											<label class="form_label" for="">官网地址：</label>
											<input type="text" class="form-control form_control" id="register_blog" placeholder="请输入官网地址" v-model.trim="tCloudUserCompany.companyUrl" />
										</section>

									</section>
								</div>
								<!-- container_box/ -->

								<div class="developer_register_btn text-center">
									<div class="issue_time_radio tip_sub_text">
										<input type="checkbox" checked class="radio_input_f" name="radio_issue_time" id="developer_register_radio" />
										<label class="form_label radio_label" for="developer_register_radio"></label>
										<span>我已阅读并同意<a class="cursor btn_a" target="_blank" @click="goAgreeMent">《开发者用户服务协议》</a></span>
									</div>
									<p>
										<span class="btn btn_issue" @click="frc">注册</span>
									</p>
								</div>

							</div>
						</section>
						<!-- container_btm/ -->
					</div>
				</div>
			</div>
		</div>

		<input type="hidden" v-model="pushRoute" />

		<!--协议弹出-->
		<transition name="slides-fade" mode="out-in">
			<v-a-modal v-if="infoFlage" title="协议详情" linkSrc="/agreement_company" @modalOff="infoFlage = !infoFlage"></v-a-modal>
		</transition>
	</div>

</template>

<script>
	import { MessageBox } from 'element-ui'
	import VAModal from './agreement_modal'
	export default {
		name: 'company_register',
		components: {
			VAModal
		},
		data() {
			return {
				infoFlage: false,
				pushRoute: '',
				provinceOptions: "",
				cityOptions: "",
				streetOptions: "",
				bankOptions: "",
				echoImg: "", //回显营业执照
				tCloudUserCompany: {
					companyName: "",
					companyNo: "",
					companyBusinessLicense: "",
					addressProvince: "",
					addressCity: "",
					addressStreet: "",
					addressDetails: "",
					companyContacts: "",
					companyPhone: "",
					email: "",
					mobile: this.$route.params.mobile,
					companyPhone: "",
					qq: "",
					companyUrl: ""
				},
				tCloudUserBankcard: {
					bankNum: '',
					cardNo: '',
					bankBranch: '',//开户支行
					cardUsername: '',
				},
				mob: this.$route.params.mobile
			}
		},
		created: function() {
			this.getSystemConfigList();
			this.initelephoto();
			this.getAllProvinceList();
		},
		computed: {

		},
		mounted: function() {
			this.$nextTick(function() {
				$("#company_no").show();
			})
		},
		methods: {
			getSystemConfigList() {
				var temp = this;
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary', {
					emulateJSON: true
				}).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '开户行'){
							temp.bankOptions = m.body.dictionaryMap[key];
						}
					}
				})
			},
			getAllProvinceList() {
				var temp = this;
				this.$http.post('/zklccloud/findAllProvinceList', {
					emulateJSON: true
				}).then(function(m) {
					temp.provinceOptions = m.body.content.provinceList;
				})
			},
			queryProvinceCity(code, level, e) {
				var temp = this;
				e = window.event || e;
				var obj = e.srcElement ? e.srcElement : e.target;
				if("" != obj.value) {
					$.ajax({
						url: "/zklccloud/queryProvinceCity",
						type: "post",
						data: {
							"code": obj.value
						},
						async: false,
						dataType: "json",
						success: function(data) {
							//组装数据
							if(level == "0") {
								temp.cityOptions = data.content.provinceCityList;
							} else if(level == "1") {
								temp.streetOptions = data.content.provinceCityList;
							}
						}
					});
				} else {
					if(level == "0") {
						temp.cityOptions = "";
					} else if(level == "1") {
						temp.streetOptions = "";
					}
				}
			},
			initelephoto() {
				if(typeof(this.$route.params.mobile) == "undefined") {
					this.$http.post('/zklccloud/queryUser', { emulateJSON: true }).then(function(m) {
						this.mob = m.body.content.mob;
						this.tCloudUserCompany.mobile = m.body.content.mob;
					})
				}
			},
			uploadPhotoz: function() {
				var temp = this;
				$("#subform").ajaxSubmit(function(data) {
					var urk = data.content.filepath;
					var urlk = urk.split("#")[1];
					if(data.resultCode == '-1') {
						if(urlk == "nottype") {
							MessageBox('格式错误，请上传图片格式jpg、png文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						} else if(urlk == "tobig") {
							MessageBox('文件过大，请上传小于1M图片文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						}
					} else if(data.resultCode == '0') {
						$(".id_card_text_hidd").hide();
						MessageBox('上传成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						$("#cardPhoto").val("已上传");
						temp.echoImg = urk;
						temp.tCloudUserCompany.companyBusinessLicense = urk;
					} else {
						MessageBox('操作失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				});
			},
			//跳转条款页
			goAgreeMent() {
				this.infoFlage = true;
				if(this.infoFlage) {
					$("body").css("overflow", "hidden")
				}
			},
			//body设置
			frc: function() {
				var temp = this;
				var companyname = $("#company_name"),
					companyNo = $("#register_companyNo"),
					addressdetail = $("#register_addressdetail"),
					email = $("#register_email"),
					spare = $("#register_spare"),
					qq = $("#register_qq"),
					blog = $("#register_blog"),
					addressprovince = $("#register_addressprovince"), //选择省份
					addresscity = $("#register_addresscity"), //选择城市
					addressstreet = $("#register_addressstreet"), //选择城市
					registeradio = $("#developer_register_radio"),
					cardphotoUrl = $("#cardPhoto"),
					bankNum = $("#bankNum"), bankBranch = $("#bankBranch"), bankCardNo = $("#bankCardNo"), cardUsername = $("#cardUsername"),
					companyContacts = $("#company_contacts");

				if(!/^([\u4E00-\u9FA5A-Za-z]{1,20})+$/.test(companyname.val())) {
					MessageBox('企业名称只允许中英文,限20个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						companyname.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == companyNo.val()) {
					MessageBox('请输入营业执照注册号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						companyNo.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} 
				/*else if(!checkCompanyNo(companyNo.val())) {
					MessageBox('请输入正确的营业执照注册号，且与企业营业执照保持一致', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						companyNo.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}*/ 
				else if(cardphotoUrl.val() == "") {
					MessageBox('请上传营业执照', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				if(addressprovince.find("option:selected").val() == "") {
					MessageBox('请选择所在省份', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				if(addresscity.find("option:selected").val() == "" || addresscity.find("option:selected").val() === undefined) {
					MessageBox('请选择所在市/县', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				if(addressstreet.find("option:selected").val() == "" || addressstreet.find("option:selected").val() === undefined) {
					MessageBox('请选择所在街镇', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == addressdetail.val()) {
					MessageBox('请输入详细联系地址', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						addressdetail.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" != addressdetail.val() && addressdetail.val().length > 20) {
					MessageBox('详细地址请输入最多20个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						addressdetail.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(bankNum.find("option:selected").val() == "") {
					MessageBox('请选择开户行', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == bankBranch.val()) {
					MessageBox('请输入开户支行', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						bankBranch.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == bankCardNo.val()) {
					MessageBox('请输入银行卡号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						bankCardNo.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^([0-9]{16}|[0-9]{19})$/.test(bankCardNo.val())) {
					MessageBox('请输入正确的银行卡号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						bankCardNo.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^([\u4E00-\u9FA5A-Za-z\s]{1,20})+$/.test(cardUsername.val())) {
					MessageBox('请输入正确的开户人姓名', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						cardUsername.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == companyContacts.val()) {
					MessageBox('请输入联系人姓名', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						companyContacts.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" != companyContacts.val() && companyContacts.val().length > 20) {
					MessageBox('联系人姓名请输入最多20个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						companyContacts.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(email.val())) {
					MessageBox('请输入正确的邮箱格式', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						email.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				if("" != spare.val()) {
					if(!checkPhone(spare.val())) {
						MessageBox('座机格式000-00000000', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							spare.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return
					}
				}
				if (qq.val() == '') {
					MessageBox('请输入QQ号码', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						qq.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^\d{5,11}$/.test(qq.val())) {
					MessageBox('请输入正确的QQ号码', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						qq.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				if("" != blog.val()) {
					if(!/(http[s]?|ftp):\/\/[^\/\.]+?\..+\w$/i.test(blog.val())) {
						MessageBox('官网地址必须以http(s)开头', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							blog.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return
					}
				}
				if($("input[type='checkbox']:checked").length == 0) {
					MessageBox('请阅读并同意《开发者用户服务协议》', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				var parameter = {
					"tCloudUserCompany": this.tCloudUserCompany,
					"tCloudUserBankcard": this.tCloudUserBankcard
				};
				this.$http.post('/zklccloud/createCompanyDev', JSON.stringify(parameter), { emulateJSON: true }).then(function(m) {
					if(m.body.resultCode == '0') {
						localStorage.setItem('loginUserType', "101006");
						MessageBox('操作成功', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							this.$router.push({
								name: 'app_index'
							})
						})
					} else if(m.body.resultCode == '-1') {
						MessageBox('注册失败，请联系管理员', '提示', 'warning', {
							confirmButtonText: '确定',
						})
					}

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
				})

			},
			routePush() {
				var temp = this;
				$("#one").find(".state_text").html("");
				this.tipMsg = "";
				setTimeout(function() {
					temp.trueFlag = false;
					temp.falseFlag = false;
				}, 300)
				if(this.pushRoute == "1") {
					this.$router.push({
						name: 'app_index'
					})
				}
			}
		}
	}

	//营业执照注册号校验
	function checkCompanyNo(value) {
		var isCompanyNo = /^\d{15}$/;
		if(isCompanyNo.test(value)) {
			return true;
		} else {
			return false;
		}
	}

	//手机号码校验
	function checkMobile(value) {
		var isMobile = /^(?:13\d|14\d|15\d|18\d|17\d)\d{5}(\d{3}|\*{3})$/;
		if(isMobile.test(value)) {
			return true;
		} else {
			return false;
		}
	}

	//座机号码校验
	function checkPhone(value) {
		var isPhone = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/;
		if(isPhone.test(value)) {
			return true;
		} else {
			return false;
		}
	}
</script>

<style scoped>
	.form_label {
		margin-right: 0;
	}
	
	.btn_a {
		text-decoration: none;
	}
	
	.id_card_box {
		margin-left: 129px;
	}
</style>


// WEBPACK FOOTER //
// company_register.vue?5f7b5c7e